import { Modelo } from '@ext/index';
import * as Types from './Pregunta.types';
import moment, { Moment } from 'moment';
import { Publicacion } from '../Publicaciones';

export class IPregunta extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Cuenta: string = '';
    public Fecha: Moment = moment( '' );
    public Publicacion: Publicacion;
    public Estado: Types.Estados;
    public Pregunta: string = '';
    public Usuario = {
        Id: 0,
        Nickname: '',
    };


    public Respuesta: string = '';
    public FechaRespuesta: Moment = moment( '' );
    public UsuarioRespuesta: number = 0;
    public UsuarioSistema = {
        Nombre: '',
        Apellido: '',
        Usuario: '',
    };

    public get Demorado(): boolean
    {
        if ( this.Fecha.isValid() )
        {
            return this.Fecha.isBefore( moment().add( -2, 'hour' ) );
        }
        return false;
    }

    public get Demora(): any
    {
        if ( this.Fecha.isValid() && this.Respuesta && this.FechaRespuesta && this.FechaRespuesta.isValid() )
        {
            return this.FechaRespuesta.from( this.Fecha, true );
        }

        return '';
    }

    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.cuenta = this.Cuenta;
        json.fecha = this.Fecha.toSQL();
        json.publicacion = this.Publicacion.Id;
        json.estado = this.Estado;
        json.pregunta = this.Pregunta;
        json.usuario = this.Usuario.Id;
        json.usuario_nickname = this.Usuario.Nickname;
        json.respuesta = this.Respuesta;
        json.fecha_respuesta = this.FechaRespuesta.toSQL();
        json.usuario_respuesta = this.UsuarioRespuesta;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Cuenta = !this.Json.cuenta ? '' : this.Json.cuenta;
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.Publicacion = new Publicacion( this.Json.publicacion );
        this.Estado = Types.Estados.toTipo( this.Json.estado );
        this.Pregunta = !this.Json.pregunta ? '' : this.Json.pregunta;
        this.Usuario.Id = !this.Json.usuario ? 0 : this.Json.usuario;
        this.Usuario.Nickname = !this.Json.usuario_nickname ? '' : this.Json.usuario_nickname;
        this.Respuesta = !this.Json.respuesta ? '' : this.Json.respuesta;
        this.FechaRespuesta = !this.Json.fecha_respuesta ? moment( '' ) : moment( this.Json.fecha_respuesta );
        this.UsuarioRespuesta = !this.Json.usuario_respuesta ? 0 : this.Json.usuario_respuesta;

        if ( this.Json.usuario_sistema && this.Json.usuario_sistema.nombre )
        {
            this.UsuarioSistema.Nombre = this.Json.usuario_sistema.nombre;
            this.UsuarioSistema.Apellido = this.Json.usuario_sistema.apellido;
            this.UsuarioSistema.Usuario = this.Json.usuario_sistema.usuario;
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IPregunta )
    {
        this.Model = Model;
    }

    public Model: IPregunta;
}